import { Icon } from 'framework7-react';

import 'framework7-icons/css/framework7-icons.css';

export const Framework7Icon = ({ name }: { name: string }) => {
  return <Icon f7={name} />;
};
